module.exports = __webpack_public_path__ + "img/we-telecom-egypt.f8a2f808.svg";